import {AfterViewInit, Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {MatTableDataSource} from "@angular/material/table";
import {MatPaginator} from "@angular/material/paginator";
import {Subject} from "rxjs";
import {AdminService} from "../services/admin.service";
import {TranslateService} from "@ngx-translate/core";
import Swal from "sweetalert2";
import {NationalDialogComponent} from "./national-dialog/national-dialog.component";
import {MatDialog} from "@angular/material/dialog";
import {EditResultComponent} from "./edit-result/edit-result.component";
import {CreateGameComponent} from "./create-game/create-game.component";

@Component({
  selector: 'app-national-games',
  templateUrl: './national-games.component.html',
  styleUrls: ['./national-games.component.scss']
})
export class NationalGamesComponent implements OnInit, AfterViewInit, OnDestroy {
  nationalGames = new MatTableDataSource<any>();
  displayedColumns: string[] = ['homeTeam', 'awayTeam', 'leagueType', 'gameDate', 'status', 'edit-result', 'open', 'remove'];
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  totalItems = 0;
  pageSize = 10;
  private destroy$ = new Subject<void>();

  constructor(
    private adminService: AdminService,
    private translate: TranslateService,
    public dialog: MatDialog
  ) {
  }

  ngOnInit() {
  }

  ngAfterViewInit() {
    this.loadData();
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  loadData() {
    this.adminService.getLastThreeGames().subscribe((result: any) => {
      if (result) {
        this.nationalGames = new MatTableDataSource(result);
        this.totalItems = result.totalElements;
        this.paginator.length = this.totalItems;
      }
    }, (error: any) => console.error(error));
  }

  deleteGame(gameId: string): void {
    this.translate.get([
      'Are you sure?',
      'You won\'t be able to revert this!',
      'Yes, delete it!',
      'No, cancel!',
      'Deleted',
      'The game has been deleted.',
      'Error',
      'An error occurred while deleting the game.'
    ]).subscribe(translations => {
      Swal.fire({
        title: translations['Are you sure?'],
        text: translations['You won\'t be able to revert this!'],
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: translations['Yes, delete it!'],
        cancelButtonText: translations['No, cancel!']
      }).then(result => {
        if (result.isConfirmed) {
          this.adminService.deleteNationalGame(gameId).subscribe(() => {
            Swal.fire(translations['Deleted'], translations['The game has been deleted.'], 'success');
            this.loadData();
          }, (error: any) => {
            Swal.fire(translations['Error'], translations['An error occurred while deleting the game.'], 'error');
          });
        }
      });
    });
  }

  openCreateNationalDialog(): void {
    const dialogRef = this.dialog.open(CreateGameComponent, {
      width: '700px',
      height: '600px',
      data: {nationalGames: null}
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.loadData();
      }
    });
  }

  openEditNationalDialog(nationalGames: any): void {
    const dialogRef = this.dialog.open(NationalDialogComponent, {
      width: '1000px',
      height: '700px',
      data: {nationalGames}
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.loadData();
      }
    });
  }

  openResultDialog(nationalGames: any): void {
    const dialogRef = this.dialog.open(EditResultComponent, {
      width: '450px',
      height: '300px',
      data: {nationalGames}
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.loadData();
      }
    });
  }

}
